















import Vue, { PropType } from 'vue';
import { mapState, mapActions } from 'vuex';
// import { countries } from './countries';
const prop = 'value',
  event = 'input';
export default Vue.extend({
  model: { prop, event },
  props: {
    value: (null as any) as PropType<any>,
    module: {
      type: String as PropType<'sponsors' | 'exhibitors'>,
      default: 'sponsors'
    },
    label: {
      type: String,
      default: 'Category'
    }
  },
  data() {
    return {
      lazyValue: this.value,
      search: ''
    };
  },
  computed: {
    ...mapState({
      sponsors: (state: any) => state.sponsors.categories,
      exhibitors: (state: any) => state.exhibitors.categories
    }),

    valueCheck(): string {
      if (this.module === 'sponsors') {
        return 'priority';
      } else {
        return 'id';
      }
    },

    categories(): any[] {
      switch (this.module) {
        case 'sponsors':
          return this.sponsors;
        case 'exhibitors':
          return this.exhibitors;
        default:
          return this.sponsors;
      }
    },
    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit(event, val);
      }
    },
    customAttrs(): object {
      return this.$attrs;
    }
  },
  methods: {
    ...mapActions({
      fetchSponsorsCategories: 'sponsors/fetchCategories',
      fetchExhibitorsCategories: 'exhibitors/fetchCategories'
    })
  },
  mounted() {
    if (this.module === 'sponsors' && !this.sponsors.length) {
      this.fetchSponsorsCategories();
    } else if (this.module === 'exhibitors' && !this.exhibitors.length) {
      this.fetchExhibitorsCategories();
    }
  }
});
